import { useArgumentsMetadataQuery } from '@tymely/services';

/**
 * Arguments metadata for the Graph Policy Editor (reduced fields per item).
 * Uses the same query key and cache as {@link useArgumentsMetadataQuery};
 * this hook is the scoped entry point for policy graph / dataset UI.
 */
export const useGraphPolicyArgumentsMetadataQuery = () => useArgumentsMetadataQuery(true);
